import {
  searchProducts_productSearch_items,
  searchProducts_productSearch_items_skuDetails,
  searchProducts_productSearch_items_productCardItems,
  searchProducts_productSearch_editPatterns
} from '@/search/queries/types/searchProducts'
import { brandCategories_categoriesByBrand } from '@/search/queries/types/brandCategories'
import { subCategories_category_subCategories } from '@/search/queries/types/subCategories'

export * from '@/search/queries/types/searchProducts'
export * from '@/search/queries/types/brandCategories'

export enum VIEW_MODES {
  SEARCH,
  SEARCH_CATEGORIES,
  SEARCH_INDUSTRIES,
  SEARCH_BRANDS,
}

export interface ProductCards {
  id: string
  productId: string
  psi: number
  categoryId: string
  industryName: string
  displayName: string
  quantityUnit: string
  secondSelectionOptionLabel: string | null
  secondSelectionOptionValue: string | null
  secondSelectionOptionTotal: string | null
  minProductPrice: number
  skuImage: string
  sizeNames: string[]
}

export interface PrintingMethodsCount {
  full: number
  single: number
}
export interface SearchParamModel {
  minUnitPrice?: number
  maxUnitPrice?: number
  categoryId: string | null
  industryIds: number[]
  brandIds: number[]
  printingMethods: string[]
  facetValueNames: Array<string>
  offset: number
  limit: number
  sortOrder: string
  keyword: string
  userDesignVersionUuid?: string
  editPatterns?: string[]
}

export interface SearchFacets {
  facetKeyName: string
  facetKeyId: string
  facetKeyDisplayName: string
  facetType: string
  canonicalSetting: string
  count: number
  facetValues: SearchFacetValues[]
}

export interface SearchFacetValues {
  count: number
  facetValueName: string
  facetValueId: string
  facetValueDisplayOrder: number
  facetValueDisplayName: string
}

export interface IndustryValue {
  id: number
  displayName: string
  industryName: string
  topPageImage: string
}

export interface BrandValue {
  id: number
  displayName: string
  brandName: string
  description: string | null
  logoImage: string | null
}

export interface FacetValuesType {
  facetKey: string
  facetValues: string[]
}

export type ProductCardModel = searchProducts_productSearch_items
export type ProductSkuDetail = searchProducts_productSearch_items_skuDetails
export type ProductCardFunction = searchProducts_productSearch_items_productCardItems
export type BrandCategory = brandCategories_categoriesByBrand
export type EditPattern = searchProducts_productSearch_editPatterns
export type SubCategory = subCategories_category_subCategories
